import { HTMLAttributes, JSX, ReactNode, SVGProps } from 'react';
import { Typography } from '../typography/typography';
import { twMerge } from 'tailwind-merge';

export type SpecProps = {
  title: string;
  value?: string | ReactNode;
  icon?: ReactNode | ((props: SVGProps<SVGSVGElement>) => JSX.Element);
  className?: string;
  isHalf?: boolean;
} & Omit<HTMLAttributes<HTMLLIElement>, 'title' | 'value'>;

export function Spec(props: SpecProps) {
  const { icon: Icon, title, value, isHalf, className, ...rest } = props;

  return (
    <li
      className={twMerge(
        'flex items-center flex-row space-x-12 ',
        !isHalf && 'justify-between',
        className,
      )}
      {...rest}
    >
      <div
        className={twMerge(
          'space-x-8 flex flex-row items-center',
          isHalf && 'w-[50%] max-w-[50%] text-left',
        )}
      >
        {Icon &&
          (typeof Icon === 'function' ? (
            <Icon className="min-w-16 w-16 h-16 fill-primaryMain" />
          ) : (
            Icon
          ))}

        <Typography
          variant="body-xs"
          weight={!value ? 'medium' : 'regular'}
          className="text-primaryMain"
        >
          {title}
        </Typography>
      </div>

      {typeof value === 'string' ? (
        <Typography
          variant="body-xs"
          weight="medium"
          className="text-primaryMain text-nowrap"
        >
          {value}
        </Typography>
      ) : (
        value
      )}
    </li>
  );
}
